import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { clearCart } from "../redux/actions/cartActions";
import Axios from "../utils/axiosInstance";

const useSubmitBooking = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, token } = useSelector((state) => state.auth);

  const submitBooking = async (data, saveInfo) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      // Step 1: Submit the order
      const orderResponse = await Axios.post(
        `${process.env.REACT_APP_API_BASE_URL}shipment/create-order/`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token.access}`,
          },
        }
      );

      toast.success(orderResponse.data.message || "Order created successfully!");

      // Step 2: Save customer info if saveInfo is true
      if (saveInfo) {
        const customerInfo = {
          name: `${data.first_name} ${data.last_name}`,
          email_address: data.email,
          address: data.address,
          phone_no: data.phone,
          city: data.city,
          postal_code: data.postal_code,
        };

        // const customerResponse = await Axios.post(
        //   `${process.env.REACT_APP_API_BASE_URL}shipment/customer/`,
        //   customerInfo,
        //   {
        //     headers: {
        //       "Content-Type": "application/json",
        //     },
        //   }
        // );
      
      }

      // Step 3: Clear the cart and navigate to the home page
      dispatch(clearCart());
      setSuccess(true);
      navigate("/");

    } catch (err) {
      const errorMessage = err.response?.data?.message || "Failed to process request. Please try again.";
      setError(errorMessage);
      toast.error(errorMessage);
      console.error("Error during submission:", err);
    } finally {
      setLoading(false);
    }
  };

  return { submitBooking, loading, error, success };
};

export default useSubmitBooking;
